import React from "react";
import Navbar from "./global-components/navbar-v3";
import PageHeader from "./global-components/page-header";
import AboutUsContent from "./section-components/about-us";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const AboutUsPage = () => {
  return (
    <div>
      <Navbar />
      <PageHeader headertitle="About Us" />
      <AboutUsContent />
      <CallToActionV1 />
      <Footer />
    </div>
  );
};

export default AboutUsPage;
